export function shorten(s: string, limit: number): string {
  if (!s || !limit) return '';

  if (s.length <= limit) {
    return s;
  }

  return s.substring(0, Math.abs(limit)) + '...';
}
